/**
 * @desc 保存竞价预告
 */
import {
  AnnouncementEntity,
  ApplyAnnouncementForm
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateApplyAnnouncementParameter = ApplyAnnouncementForm

const method = 'POST'
const url = '/trade/operation/announcement/apply'

export const createApplyAnnouncementApi = (
  data?: CreateApplyAnnouncementParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AnnouncementEntity>({
    method,
    url,
    data,
    ...config
  })
}

createApplyAnnouncementApi.method = method
createApplyAnnouncementApi.url = url
